import clsx from "clsx";

export function YoutubeIcon({ className = '' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="22"
      viewBox="0 0 30 22"
      className={clsx('text-[#5B5B5B]', className)}
      aria-hidden="true"
    >
      <path
        d="M23.6543 0.666992H6.73981C3.42121 0.666992 0.730957 3.35725 0.730957 6.67585V15.1313C0.730957 18.4499 3.42121 21.1402 6.73981 21.1402H23.6543C26.9729 21.1402 29.6632 18.4499 29.6632 15.1313V6.67585C29.6632 3.35725 26.9729 0.666992 23.6543 0.666992ZM19.5906 11.315L11.6791 15.0883C11.4683 15.1888 11.2248 15.0351 11.2248 14.8016V7.01914C11.2248 6.78229 11.4747 6.62878 11.686 6.73585L19.5974 10.745C19.8327 10.8642 19.8286 11.2015 19.5906 11.315Z"
        fill="currentColor" // חשוב מאוד!
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </svg>
  )
}
